import React from 'react';
import style from './style.scss';
import Product from 'components/partials/product';
import {Businesses} from 'api';

class OtherProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: []
    };
  }

  componentDidMount() {
    if (this.props.businessId) {
      const params = {
        id: this.props.businessId,
        filter: {
          limit: 6,
          where: {
            id: {
              neq: this.props.productId
            }
          }
        }
      };
      Businesses.actions.listProducts.request(params).then(response => {
        this.setState({data: response.data});
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.businessId) {
      const params = {
        id: nextProps.businessId,
        filter: {
          limit: 6,
          where: {
            id: {
              neq: nextProps.productId
            }
          }
        }
      };
      Businesses.actions.listProducts.request(params).then(response => {
        this.setState({data: response.data});
      });
    }
  }


  render() {
    if (this.state.data.length === 0) {
      return null;
    }
    return (
      <section className="other-product-popup">
        <h3 className='title-other-product-popup'>Các sản phẩm khác của doanh nghiệp</h3>
        <div className='wrap-other-product'>
          {
            this.state.data.map((item, i) => {
              return (
                <Product key={i} {...item} fixHeightContent={false}/>
              );
            })
          }
        </div>
      </section>
    );
  }
}

export default OtherProduct;



// WEBPACK FOOTER //
// ./components/partials/product/popup-view-detail/other-product/OtherProduct.jsx